import DeliveriesController from 'cio/controllers/deliveries';

export default class TransactionalMessageOverviewDraftsController extends DeliveriesController {
  filterQueryParams = ['action', 'recipient'];
  queryParams = ['startTs', 'endTs'];
  detailRoute = 'transactional.message.overview.drafts.draft';

  icon = 'draft';
  fetchDrafted = true;
  drafted = true;
}
